<template>
  <div
    class="jade-toast-hub"
    :style="{ zIndex }"
  >
    <transition-group
      name="list"
      tag="div"
    >
      <div
        v-for="(toast, index) in toasts.getQueue()"
        :key="`key-${index}`"
        class="jade-toast-hub__toast"
      >
        <div class="jade-toast-hub__toast-container">
          <jade-toast
            :text="toast.text"
            :actionName="toast.actionName"
            @handleClick="() => toasts.remove(index)"
          >
            <template #leading>
              <jade-spinner
                v-if="toast.loading"
                size="large"
                color="on-color-high"
              />
              <jade-icon
                v-else
                color="on-color-high"
                size="large"
                :use="toast.icon"
              />
            </template>
          </jade-toast>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import JadeToast from '../JadeToast/index.vue'
import JadeIcon from '../JadeIcon/index.vue'
import JadeSpinner from '../JadeSpinner/index.vue'
import Queue from '../utils/queue.utils'

const DURATION_ENUM = {
  short: 3000,
  medium: 5000,
  long: 8000,
  indeterminate: Infinity
}

export default {
  name: 'JadeToastHub',
  components: {
    JadeToast,
    JadeIcon,
    JadeSpinner
  },
  data () {
    return {
      toasts: new Queue()
    }
  },
  props: {
    zIndex: {
      type: [String, Number],
      default: 1201
    },
    duration: {
      type: [String, Number],
      validation: duration =>
        [
          DURATION_ENUM.short,
          DURATION_ENUM.medium,
          DURATION_ENUM.long,
          DURATION_ENUM.indeterminate
        ].includes(duration),
      default: 'short'
    }
  },
  computed: {
    isIndeterminate () {
      return DURATION_ENUM[this.duration] === DURATION_ENUM.indeterminate
    }
  },
  methods: {
    removeToast () {
      this.toasts.pop()
    },

    addToast (item) {
      if (typeof item !== 'object') {
        throw new Error('Item type is not an object')
      }

      this.toasts.push(item)

      if (this.isIndeterminate) {
        return
      }

      setTimeout(this.removeToast, DURATION_ENUM[this.duration])
    }
  }
}
</script>

<style scoped>
.jade-toast-hub__toast {
  margin-bottom: var(--global-space-150, 12px);
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.7s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>
